import { useEffect, useState } from "react";

/**
 * Returns `true` when a new Service Worker version is waiting to be activated.
 * Listens for the `hosys:sw-update-available` custom event dispatched by swRegistration.js.
 */
export default function useSWUpdateAvailable() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    const handler = () => setAvailable(true);
    window.addEventListener("hosys:sw-update-available", handler);
    return () => window.removeEventListener("hosys:sw-update-available", handler);
  }, []);

  return available;
}
